import { render } from "./RelatedArticles.vue?vue&type=template&id=763d06b2&scoped=true"
import script from "./RelatedArticles.vue?vue&type=script&lang=js"
export * from "./RelatedArticles.vue?vue&type=script&lang=js"

import "./RelatedArticles.vue?vue&type=style&index=0&id=763d06b2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-763d06b2"

export default script